<template>
    <div class="modal fade" id="administrator_quick_add" tabindex="-1" role="dialog"
         aria-labelledby="administrator_quick_add_title"
         aria-hidden="true">
        <div :class="'modal-dialog modal-dialog-centered ' + lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="administrator_quick_add_title">{{ 'title' }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="! mode" class="row">
                        <div class="btn btn-info btn-lg col-5 py-4 mx-2"
                             v-for="option in modeOptions"
                             @click="mode = option"
                        >
                            {{ option }}
                        </div>
                    </div>
                    <div v-else-if="mode == 'permissions'">
                        <b-form-group label="Stacked  checkboxes"
                                      :class="[ permissionsRequired ? 'text-danger' : '' ]">
                            <b-form-checkbox-group stacked v-model="permissionsSelected"
                                                   name="permissions_to_add"
                                                   :options="permissions"
                            ></b-form-checkbox-group>
                        </b-form-group>
                    </div>
                    <div v-else-if="mode == 'users'">
                        <b-form-group label="Stacked  checkboxes"
                                      :class="[ usersRequired ? 'text-danger' : '' ]">
                            <b-form-checkbox-group stacked v-model="usersSelected"
                                                   name="users_to_add"
                                                   :options="users"
                            ></b-form-checkbox-group>
                        </b-form-group>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-white"
                            data-dismiss="modal"
                            @click="dismiss">
                        {{ 'cancel' }}
                    </button>
                    <button type="button"
                            class="btn btn-blue"
                            @click="next"
                    >
                        {{ this.valid ? 'submit' : 'next' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                modeOptions: ['permissions', 'users'],
                mode: '',
                permissions: [],
                users: [],
                permissionsSelected: [],
                usersSelected: [],
                permissionsRequired: false,
                usersRequired: false,
            };
        },
        props: {
            lang: {
                type: Object,
            },
            small_modal: {
                type: Boolean,
                default: () => {
                    return false;
                }
            },
        },
        computed: {
            lg() {
                return this.small_modal ? '' : 'modal-lg';
            },
            valid() {
                return this.permissionsSelected.length && this.usersSelected.length;
            }
        },
        mounted() {
            let self = this;

            $('#administrator_quick_add').on('hidden.bs.modal', function () {
                self.dismiss();
            })

            axios.get('/system-management/system-settings/administrator/list-by-permission?for_list=0')
                .then(response => {
                    self.permissions = _.transform(response.data.data, function (result, permission) {
                        result.push({
                            text: permission.display_name,
                            value: permission.id
                        });
                        return result;
                    })
                });

            axios.get('/system-management/system-settings/administrator/list-by-user?for_list=0&all_user=1')
                .then(response => {
                    self.users = _.transform(response.data.data, function (result, user) {
                        result.push({
                            text: user.name,
                            value: user.id
                        });
                        return result;
                    })
                });
        },
        methods: {
            dismiss() {
                this.mode = '';
                this.permissionsSelected = [];
                this.usersSelected = [];
                this.permissionsRequired = false;
                this.usersRequired = false;
            },
            toggle() {
                $('#administrator_quick_add').modal('toggle');
            },
            next() {
                if (this.valid) {
                    let self = this;

                    axios.post('/system-management/system-settings/administrator/assign', {
                        permissions: self.permissionsSelected,
                        users: self.usersSelected,
                    })
                        .then(response => {
                            self.toggle();
                            self.$store.commit('setNotification', response.data.msg);
							window.eventHub.$emit('refresh-data');
                        })
                        .catch(error => {
                            if (error.response.status == '422') {
                                self.$store.commit('setValidationError', error.response.data.errors)
                            } else {
                                self.$store.commit('setError', error.response.data.msg)
                            }
                        });
                } else {
                    // next
                    if (this.mode == this.modeOptions[0]) {
                        // permissions
                        this.permissionsSelected.length ?
                            this.mode = this.modeOptions[1] :
                            this.permissionsRequired = true;
                    } else {
                        // users
                        this.usersSelected.length ?
                            this.mode = this.modeOptions[0] :
                            this.usersRequired = true;
                    }
                }

            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/system-management/administrator/QuickAdd.vue